var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,0H5l-1,1V6H2l-1,1v11l1,1h2v4l1,1H21l1-1V1l-1-1Zm-1,22H6v-3h14v3Zm0-5H3V8H20v9Zm0-11H6V2h14V6ZM6,14h1.71l1.29-1.29v-1.41l-1.29-1.29h-2.71v5h1v-1Zm0-3h1.29l.71,.71v.59l-.71,.71h-1.29v-2Zm8,2.71v-2.41l-1.29-1.29h-2.71v5h2.71l1.29-1.29Zm-3,.29v-3h1.29l.71,.71v1.59l-.71,.71h-1.29Zm5,1h-1v-5h3v1h-2v1h2v1h-2v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/1775031319/media/icon-pdf.a22b615984f13ce07f090ec67ef50dd9.svg";
export { ForwardRef as ReactComponent };